var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.closeSearchBrandDropdown}},[_c('RetailerHeader',{attrs:{"showBrandDropdown":_vm.showBrandDropdown}}),_c('router-view'),_c('RetailerFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }